import {useLocation, Link} from 'react-router-dom'
import {useEffect} from 'react'
const paths = [
  {title: 'Sales', path: '/register/sales'},
  {title: 'Purchases', path: '/register/purchase'},
  {title: 'Receivables', path: '/register/receivables'},
  {title: 'Payables', path: '/register/payables'},
  {title: 'Credit Note', path: '/register/creditnote'},
  {title: 'Debit Note', path: '/register/debitnote'},
]

export const HeaderTabs: React.FC<{setActiveTab: React.Dispatch<React.SetStateAction<string>>}> = ({
  setActiveTab,
}) => {
  const location = useLocation()

  return (
    <div className='card mb-5'>
      <div className='card-body pt-1 pb-1'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {paths.map((p, i) => (
              <li className='nav-item' key={p.path + i}>
                <Link
                  className={
                    `nav-link text-active-primary me-6 ` +
                    (location.pathname === p.path && 'active')
                  }
                  onClick={() => setActiveTab(p.path.split('/')[2])}
                  to={p.path}
                >
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
